import {
  Input,SimpleChanges,OnChanges,
  Component,
  OnInit,
  Inject
} from '@angular/core';
import {Router, ActivatedRoute, Params,Event, RouteConfigLoadEnd, NavigationEnd, NavigationError} from '@angular/router';
import {ImageVM} from "../../models/ImageVM.model";
import {CompanyVM} from "../../models/CompanyVM.model";
import {CompanyService} from "../../services/company-service/company-service";
import {WorkSpaceVMModel} from "../../models/WorkSpaceVMModel";
import {MarkerVMModel} from "../../models/MarkerModel";
import {SharingService} from "../../services/sharing/sharing.service";
import {ScheduleInfoDTO, WEEKDAYS, WorkDayVM} from "../../models/ServiceItemDetailVM";
import {DOCUMENT} from '@angular/platform-browser';
import {IAppConfig} from "../../models/app-config.model";
import {AppConfig} from "../../services/app.config";

@Component({

  selector: 'rw-company-footer',  // <home></home>

  styles: [require('./company-footer.component.css')],

  template: require('./company-footer.component.html'),
  host: {
    '(window:resize)': 'onResize($event)'
  }

})
export class CompanyFooterComponent implements OnInit,OnChanges {

  companyDetail:CompanyVM;
  public coverImage:ImageVM;
  public imageUrl:String;
  mobileScreen:boolean = false;
  workingTime:ScheduleInfoDTO;
  public workingDays:WorkDayVM[] = [];
  public companySocials:any[];
  private workSpaceList:WorkSpaceVMModel[] = [];
  public currentLocation:MarkerVMModel;
  companyKeyUrl = null;
  showMap :boolean = true;
  showWorkingTime :boolean = true;
  // @Input() showName?: boolean;

  /**
   * TypeScript public modifiers
   */
  constructor(private sharingService:SharingService, private router:Router, private activatedRoute:ActivatedRoute, private companyService:CompanyService,@Inject (DOCUMENT) private document: any) {

    this.router.events.subscribe((event: Event) => {
       if (event instanceof NavigationEnd ) {
        this.routeChanged(event.url);
       }
      if (event instanceof RouteConfigLoadEnd) {
        let url = this.document.location.href;
        this.routeChanged(url);
      }

    });

  }
  public imageList:ImageVM[];

  public routeChanged(url)
  {
    let parent=this;
    parent.companyKeyUrl = null;
    if(url && url.includes('companyProfile'))
    {
      let keyUrl = url.substring(url.lastIndexOf('/')+1,url.length);
      parent.companyKeyUrl = keyUrl;
    }
    this.ngOnInit();

  }

  public ngOnInit() {
    if (window.innerWidth > 767){
      this.mobileScreen = false;
    } else {
      this.mobileScreen = true;
    }


    let parent=this;
    this.companyService.getCompanyInfo(this.companyKeyUrl).subscribe((c)=> {
      this.companyDetail = c;
      this.checkThemeSetting(c);
      this.fillCompanyWorkingTime();
      this.makeSocialNetworkList();
      this.makeWorkSpaceList();
    })

  }

  ngOnChanges(changes:SimpleChanges):void {

    let parent = this;
  }


  private fillCompanyWorkingTime() {
    if (this.companyDetail) {
      this.companyService.getCompanyWorkingTime(this.companyDetail.id).subscribe(wt=> {
        this.workingTime = wt;
        //this.makeWorkindDays(this.workingTime);
        this.makeWorkindDays(wt);

        // this.inited=true;

      });

    }
  }

  private makeWorkindDays(workingTime:ScheduleInfoDTO):void {
    let parent = this;
    parent.workingDays = [];
    if (workingTime && workingTime.weeklyScheduleInfo && workingTime.weeklyScheduleInfo.weekdays.length !== 0) {
      var weekdays = Object.keys(WEEKDAYS);
      var WEEKDAYS_ENUM=WEEKDAYS;
      weekdays = weekdays.slice(weekdays.length / 2, weekdays.length );
      weekdays.forEach((day)=> {
        let foundIndex = workingTime.weeklyScheduleInfo.weekdays.findIndex((item)=> {
          if (item.weekday.toString() == day)return true;
        })

        if (foundIndex > -1) {
          let cworkday = workingTime.weeklyScheduleInfo.weekdays[foundIndex];
          let workday:WorkDayVM = new WorkDayVM();
          workday.weekday =day.toString();
          if (cworkday.timePeriod)
            workday.timePeriod = cworkday.timePeriod;
          else
            workday.timePeriod = workingTime.weeklyScheduleInfo.timePeriod;
          parent.workingDays.push(workday)
        }

      })

    } else {
      this.workingDays = null;
    }
  }

  makeSocialNetworkList() {
    if (this.companyDetail)
      this.companyService.getCompanySocialNetwork(this.companyDetail.id).subscribe((sns)=> {
        this.companySocials = sns;

        // (MA)I put this part here because it needs to be checked after the service completely loaded,
        // so to have an unnoticed delay I put it here after above service loaded
      })
  }

  clickOnSocialNetwork(socialNetwork) {
    if (socialNetwork.socialNetworkType == 'TELEGRAM') {
      window.open('https://telegram.me/' + socialNetwork.url, "_blank");
    }
    else if (socialNetwork.socialNetworkType == 'INSTAGRAM') {
      window.open('https://instagram.com/' + socialNetwork.url, "_blank");
    }
    if (socialNetwork.socialNetworkType == 'LINKEDIN') {
      window.open(socialNetwork.url, "_blank");
    }
    if (socialNetwork.socialNetworkType == 'WHATSAPP') {
      let url = "https://api.whatsapp.com/send?phone=";
      url = url + socialNetwork.url;
      window.open(url, "_blank");
    }
  }

  makeWorkSpaceList() {
    let parent = this;
    let com = this.companyDetail;
    if (com.location && com.location.mapY && com.location.mapX) {

      let o1 = new MarkerVMModel(+com.location.mapX, +com.location.mapY);
      this.currentLocation = new MarkerVMModel(+com.location.mapX, +com.location.mapY);
      let workSpace = new WorkSpaceVMModel(o1);
      workSpace.title = com.title;
      workSpace.detail = com.location.address
      // parent.companyService.getCompanyLogoImage(com).subscribe(((logo)=> {
      //   workSpace.image = logo;
      // }))
      parent.workSpaceList.push(workSpace);
    }
    else
    {
      this.initCurrentLocation();
    }


  }

  initCurrentLocation() {
    this.currentLocation=new MarkerVMModel(35.736365,51.375714);
  }

  onResize(event){
    if (window.innerWidth > 767){
      this.mobileScreen = false;
    } else {
      this.mobileScreen = true;
    }
  }
  checkThemeSetting(company){

    const parent = this;
    if (company && company.setting && company.setting.themeSettingInfo
      && company.setting.themeSettingInfo.mapVisibility && company.setting.themeSettingInfo.mapVisibility =='HIDE')
      parent.showMap = false;
    else
      parent.showMap = true;


    if (company && company.setting && company.setting.themeSettingInfo
      && company.setting.themeSettingInfo.workingTimeVisibility && company.setting.themeSettingInfo.workingTimeVisibility =='HIDE')
      parent.showWorkingTime = false;
    else
      parent.showWorkingTime = true;


  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/company-footer/company-footer.component.ts